import React from 'react'
import PropTypes from 'prop-types'

import { QuestionnaireLinearProgressTable } from '../../components'
import helpers from 'helpers'

const ComplianceByQuestionnaire = ({ questionnaires, ...rest }) => {
  const rows = helpers.myLgpd.mountComplianceRows(questionnaires)

  return (
    <QuestionnaireLinearProgressTable
      title="Conformidade por questionário"
      questionnaires={rows}
      percentage
      {...rest}
    />
  )
}

ComplianceByQuestionnaire.propTypes = {
  questionnaires: PropTypes.array.isRequired,
}

export default ComplianceByQuestionnaire
